import { Badge, FontIcon, LazyImage, Text } from '@intigral/shared';
import { IProgramPoster } from '../../types/iProgram';
import styles from '../styles/tvguide.module.sass';
import { isReminderSetForProgram } from '../../utils/ProgramUtils';
import { isEpgProgramParentalBlocked } from '../../utils/parentalControl';
import { useEpgLocalization } from '../../hooks';
import { EpgParentalLockOverlay } from './EpgParentalLockOverlay';
import { isUserInGracePeriod } from '@intigral/utils';

export const ProgramPoster: React.FC<IProgramPoster> = ({
    isFutureProgram,
    selectedProgram,
    isShowEpgLock,
    isReminderSet,
    reminderData,
}) => {
    const reminderSet = isReminderSet || isReminderSetForProgram(selectedProgram, reminderData || []);
    const localization = useEpgLocalization();
    const isParentalBlocked = isEpgProgramParentalBlocked(selectedProgram);
    const isGracePeriod = isUserInGracePeriod();

    if (isParentalBlocked) {
        return <EpgParentalLockOverlay />;
    }

    if (isFutureProgram) {
        return (
            <div>
                <div className={styles.picture}>
                    <LazyImage key={selectedProgram?.image} src={selectedProgram?.image || ''} alt="poster image" />
                </div>
                <div className={styles['reminder-icon']}>
                    <FontIcon name="bell-filled-circle" size="x-large" md="x-large" />
                    {(reminderSet || isReminderSet) && (
                        <Badge fullRadius isSmall className={styles['reminder-set']}>
                            <FontIcon name="check-green" size="smaller" md="x-small" />
                        </Badge>
                    )}
                </div>
            </div>
        );
    }

    if (isShowEpgLock) {
        // return <div>You are not entitled to see this program please upgrade you plan.</div>;
        return (
            <div className={styles.locked}>
                <FontIcon name="lock-filled" size="medium" md="small" />
                <Text as="span" color="white" fontWeight="medium">
                    {localization?.freeTier_player_streamConcurrency_errorTitle}
                </Text>

                {!selectedProgram?.isPPV && (
                    <Text as="span" size={{ default: '12', md: '14' }}>
                        {isGracePeriod ? localization?.live_tv_grace_period_error : localization?.upgrade_plan_message}
                    </Text>
                )}
            </div>
        );
    }

    return null;
};
